module.exports = __webpack_public_path__ + "img/loading.5680cc46.svg";